import React, {useState, useImperativeHandle, forwardRef} from 'react'
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';


const FilterDropdown = ({ onChange, data, placeholder, blankMenuLabel, id, selected ="" }, refPassed) => {
    const [value, setValue] = useState(selected);
    const [open, setOpen] = useState(false);
    useImperativeHandle(refPassed, ()=>({
        reset:()=>{
            setValue(selected);
        }
    }))
    
    function handleCloseDropdown() {
        setOpen(false);
    }
    const onChangeHandler = (evt)=> {
        setValue(evt.target.value)
        onChange(evt.target)
    }

    function handleOpen() {
        setOpen(true);
    }
    return (
        <FormControl>
            <InputLabel htmlFor={id}>{placeholder}</InputLabel>
            <Select className="year-dropdown"
                open={open}
                onClose={handleCloseDropdown}
                onOpen={handleOpen}
                displayEmpty
                value={value}
                onChange={onChangeHandler}
                inputProps={{
                    name: id,
                    id: id,
                }}
            >
                <MenuItem value="" selected>{blankMenuLabel}</MenuItem>
                {data.map(el => { return (el !== "") ? (<MenuItem key={el} value={el}>{el}</MenuItem>) : "" })}
            </Select>

        </FormControl>
    )
}

export default forwardRef(FilterDropdown)
